import { cva, type VariantProps } from "class-variance-authority";

/**
 * The mobile floor is an absolute `16px`, not `text-base`: the root font size is
 * 81.25% (13px at the default browser setting), so a rem-relative `text-base` computes to 13px and iOS
 * Safari still auto-zooms the focused control. Desktop typography (`text-sm`)
 * is unchanged.
 */
export const controlVariants = cva(
  "w-full rounded-md border border-input bg-input-background text-sm outline-none transition-[border-color,box-shadow] placeholder:text-input-placeholder focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-[var(--input-invalid-ring)] max-md:text-[16px]",
  {
    variants: {
      size: {
        sm: "h-8",
        default: "h-9",
        touch: "h-[44px]",
        mobileTouch: "h-9 max-md:h-[44px]",
      },
    },
    defaultVariants: { size: "default" },
  },
);

export type ControlSize = NonNullable<VariantProps<typeof controlVariants>["size"]>;
